import { CheckCircleIcon } from "../../shared/Icons";
import { themeAtom } from "../../shared/atoms";
import Modal from "../../shared/components/ModalWindow";
import { useAtomValue } from "jotai";
import { ReactNode, useState } from "react";
import { twMerge } from "tailwind-merge";

type RequestSentModalProps = {
  isModalOpen: boolean;
  title: string;
  caption: string | ReactNode;
  onDismiss?: (isHideMessageChecked?: boolean) => void;
};

export function RequestSentModal({ isModalOpen, title, caption, onDismiss }: RequestSentModalProps) {
  const theme = useAtomValue(themeAtom);

  const [isHideMessageChecked, setIsHideMessageChecked] = useState(false);
  return (
    <Modal isOpen={isModalOpen}>
      <div className={twMerge("flex flex-col items-center p-4", theme.home.tailwind.textDefault)}>
        <CheckCircleIcon className="h-14 w-14" color="#658d1b" />

        <div className="pb-4 pt-8 text-center font-bold">{title}</div>

        <div className={twMerge("pb-10 text-center text-sm", theme.uwhcAssistant.text)}>{caption}</div>
        <button
          className={twMerge(
            "w-[220px] rounded border bg-green px-4 py-2",
            theme.warningFunction.text,
            theme.uwhcAssistant.border,
          )}
          onClick={() => onDismiss?.(isHideMessageChecked)}
        >
          Close
        </button>

        <div className={twMerge("flex flex-row pb-2 pt-5 text-sm", theme.home.tailwind.textDefault)}>
          <input
            type="checkbox"
            checked={isHideMessageChecked}
            onChange={() => setIsHideMessageChecked((prev) => !prev)}
            className="form-checkbox mt-[1px] h-4 w-4 rounded text-green"
          />
          <div className="pl-2">Don't show this message again</div>
        </div>
      </div>
    </Modal>
  );
}
